import { gql } from 'apollo-boost';

export const UPDATE_SLACK_INTEGRATION = gql`
    mutation UpdateSlackIntegration($data: UpdateSlackIntegrationInput!) {
        updateSlackIntegration(data: $data) {
            id
            integrations {
                slack {
                    slackUserId
                    teamId
                    username
                    workspaceName
                    displayName
                    connectedAt
                }
            }
        }
    }
`;
